$('#codeEnergie').addClass('tego-displayselect');
$('.tego-displayselect').displayselect();
